import usePutRequest from '../utils/usePutRequest';
import { CreatedInterfaces } from '../../interfaces';
import { getErrorMessage } from '../../utils/errorCodes';

const resource = 'card-product-update'

const useUpdateCardProduct = (cardProductId: string) => {
  const [{ updatedData, updatedError, updatedLoading }, updateCardProduct] = usePutRequest<CreatedInterfaces<typeof resource>>({
    path: `v1/card_products/${cardProductId}`
  });

  return {
    isLoading: updatedLoading,
    isError: getErrorMessage(updatedError?.response?.data?.errors[0]?.message),
    updateCardProduct,
    cardProduct: updatedData
  };
};

export default useUpdateCardProduct;